import { Step } from "react-joyride";

export const preApprovalSteps: Step[] = [
	{
		target: '[data-testid="preview-tabs"]',
		content: (
			<div className="text-sm">
				<h3 className="mb-2 text-lg font-semibold">Welcome to Procuracon</h3>
				<p>You've been asked to review and approve an RFx.</p>
				<p>
					<br />
					To begin, select the tabs to explore the RFx details and supporting
					information.
				</p>
			</div>
		),
		placement: "bottom",
		disableBeacon: true,
		styles: {
			options: {
				primaryColor: "#4F46E5",
			},
		},
	},
	{
		target: '[data-testid="approval-action-button"]',
		content: (
			<div>
				<h3 className="mb-2 text-lg font-semibold">Approval Process</h3>
				<p className="text-sm">
					Once you've finished your review, click here to provide your approval
					and add any additional comments.
				</p>
			</div>
		),
		placement: "bottom",
		styles: {
			options: {
				primaryColor: "#4F46E5",
			},
		},
	},
];
